<template>
  <div>
    <b-table
      :items="items"
      :busy="loading"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      stacked="md"
      show-empty
      small
      empty-text="No Product Catalogues found."
    >
      <template #table-busy>
        <div class="text-center text-info my-2">
          <b-spinner class="align-middle" />
          <strong>Loading Catalogues...</strong>
        </div>
      </template>
      <template #empty="scope">
        <div class="text-center py-4">
          <h5 class="error-empty-catalogues">
            {{ scope.emptyText }}
          </h5>
          <b-btn
            to="/catalogues/new"
            variant="primary"
          >
            Create Product Catalogue
          </b-btn>
        </div>
      </template>

      <template #cell(productsCount)="row">
        <span>
          {{ row.item.products.length }}
        </span>
      </template>

      <template #cell(active)="row">
        {{ row.item.active | publishedStatus }}
      </template>
      <template #cell(actions)="row">
        <b-dropdown
          id="dropdown-1"
          text="Select"
          class="m-md-2"
          no-caret
        >
          <template #button-content>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-three-dots-vertical"
              viewBox="0 0 16 16"
            >
              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
            </svg>
          </template>
          <b-dropdown-item
            :to="`/catalogues/edit/${row.item.uuid}`"
          >
            Edit Catalogue
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="items.length"
      :per-page="perPage"
      first-text="First"
      prev-text="Prev"
      next-text="Next"
      last-text="Last"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  filters: {
    publishedStatus: (value) => {
      return value ? 'Published' : 'Unpublished'
    }
  },
  data() {
    return {
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'description', label: 'Description' },
        { key: 'productsCount', label: 'Products Assigned' },
        { key: 'active', label: 'Status' },
        { key: 'actions', label: 'Actions' }
      ],
      currentPage: 1,
      perPage: 10
    }
  },
  computed: {
    ...mapGetters({
      catalogues: 'catalogues/all',
      loading: 'catalogues/loading'
    }),
    items() {
      const catalogueItems = Object.values(this.catalogues)
      if (!catalogueItems.length) return []
      return catalogueItems
    }
  }
}
</script>

<style lang="scss" scoped>
  .error-empty-catalogues{
    margin-bottom: 2rem;
  }
</style>
